<template>
	<v-dialog v-model="value" persistent max-width="600px">
		<v-card>
			<v-card-title>
				<span class="headline">Cambiar Contraseña</span>
			</v-card-title>
			<v-card-text>
				<v-container grid-list-md>
					<v-layout wrap>
						<v-flex xs12 sm6 md4>
							<v-text-field
								type="password"
								v-model="$v.passwordForm.currentPassword.$model"
								label="Contraseña actual"
								required
								:error-messages="currentPasswordErrors"
							></v-text-field>
						</v-flex>
						<v-flex xs12 sm6 md4>
							<v-text-field
								type="password"
								v-model="$v.passwordForm.newPassword.$model"
								label="Nueva contraseña"
								:error-messages="newPasswordErrors"
								loading
							>
								<template v-slot:progress>
									<v-progress-linear :value="progress" :color="color" height="2"></v-progress-linear>
								</template>
							</v-text-field>
						</v-flex>
						<v-flex xs12 sm6 md4>
							<v-text-field
								type="password"
								v-model="$v.passwordForm.confirmPassword.$model"
								label="Confirmar contraseña"
								:error-messages="confirmPasswordErrors"
							></v-text-field>
						</v-flex>
					</v-layout>
				</v-container>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn @click="close" flat>Cancelar</v-btn>
				<v-btn @click="update" color="primary" flat>Cambiar</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	import { required, sameAs } from "vuelidate/lib/validators";
	export default {
		props: ["value"],
		validations: {
			passwordForm: {
				currentPassword: { required },
				newPassword: { required },
				confirmPassword: { required, sameAsPassword: sameAs("newPassword") }
			}
		},
		data: () => ({
			passwordForm: {
				currentPassword: "",
				newPassword: "",
				confirmPassword: ""
			}
		}),
		methods: {
			close() {
				this.$emit("input", !this.value);
			},
			update() {
				this.$v.passwordForm.$touch();
				if (!this.$v.passwordForm.$invalid) {
					this.$emit("Update", this.passwordForm);
				}
			}
		},
		computed: {
			progress() {
				var matchedCase = new Array();
				matchedCase.push("[$@$!%*#?&]"); // Special Charector
				matchedCase.push("[A-Z]"); // Uppercase Alpabates
				matchedCase.push("[0-9]"); // Numbers
				matchedCase.push("[a-z]"); // Lowercase Alphabates
				var ctr = 0;
				if (this.passwordForm.newPassword.length > 6) ctr += 20;
				for (var i = 0; i < matchedCase.length; i++) {
					if (new RegExp(matchedCase[i]).test(this.passwordForm.newPassword)) {
						ctr += 20;
					}
				}
				return ctr;
			},
			color() {
				var matchedCase = new Array();
				matchedCase.push("[$@$!%*#?&]"); // Special Charector
				matchedCase.push("[A-Z]"); // Uppercase Alpabates
				matchedCase.push("[0-9]"); // Numbers
				matchedCase.push("[a-z]"); // Lowercase Alphabates
				var ctr = 0;
				if (this.passwordForm.newPassword.length > 6) ctr += 20;
				for (var i = 0; i < matchedCase.length; i++) {
					if (new RegExp(matchedCase[i]).test(this.passwordForm.newPassword)) {
						ctr += 20;
					}
				}
				// Display it
				var color = "";
				var strength = "";
				if (ctr >= 20 && ctr < 40) {
					return "error";
				}
				if (ctr >= 40 && ctr < 60) {
					return "warning";
				}
				if (ctr >= 60 && ctr < 80) {
					return "warning";
				}
				if (ctr >= 80 && ctr <= 100) {
					return "success";
				}
			},
			currentPasswordErrors() {
				const errors = [];
				if (!this.$v.passwordForm.currentPassword.$dirty) return errors;
				!this.$v.passwordForm.currentPassword.required &&
					errors.push("Contraseña requerida");
				return errors;
			},
			newPasswordErrors() {
				const errors = [];
				if (!this.$v.passwordForm.newPassword.$dirty) return errors;
				!this.$v.passwordForm.newPassword.required &&
					errors.push("Nueva contraseña requerida");
				return errors;
			},
			confirmPasswordErrors() {
				const errors = [];
				if (!this.$v.passwordForm.confirmPassword.$dirty) return errors;
				!this.$v.passwordForm.confirmPassword.required &&
					errors.push("Confirmación de contraseña requerida");
				!this.$v.passwordForm.confirmPassword.sameAsPassword &&
					errors.push("Las contraseñas no coinciden");

				return errors;
			}
		}
	};
</script>

<style>
</style>
